enum Availability {
    MonAM = "MonAM",
    MonPM = "MonPM",
    TueAM = "TueAM",
    TuePM = "TuePM",
    WedAM = "WedAM",
    WedPM = "WedPM",
    ThuAM = "ThuAM",
    ThuPM = "ThuPM",
    FriAM = "FriAM",
    FriPM = "FriPM",
    SatAM = "SatAM",
    SatPM = "SatPM",
    SunAM = "SunAM",
    SunPM = "SunPM",
}

export default Availability;